<template>
  <div class="page-template">
    <div class="topbar">
      <div class="main">
        <div class="topbar_left">欢迎使用{{ basic.web_name }}</div>
        <div class="topbar_right">
          <a @click="$router.push('/query')">订单查询</a>
          <a :href="basic.help_qq" target="_blank">联系客服</a>
        </div>
      </div>
    </div>
    <!-- logo、搜索 -->
    <div class="midbar">
      <div class="main">
        <div class="midbar_left">
          <a href="/">
            <img :src="basic.web_logo" v-if="basic.web_logo" alt />
            <div class="spin-container" v-else>
              <Spin size="large" fix></Spin>
            </div>
          </a>
        </div>
        <div class="midbar_right">
          <div class="search">
            <div class="search-main" :style="`border:solid 2px ${basic.pcHeadBg?basic.pcHeadBg:'#ff6034'}`">
              <input type="text" class="search-input" v-model="search" placeholder="输入关键词搜索" />
              <button class="search-button" @click="searchClick"
                :style="`background:${basic.pcHeadBg?basic.pcHeadBg:'#ff6034'}`">搜索</button>
            </div>
            <ul>
              <li v-for="item in SalesShop" :key="item.id"  @click="$router.replace('/details/' + item.id)">
                {{ item.name }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- 分类导航 -->
    <div class="navbar" :style="`background:${basic.pcHeadBg?basic.pcHeadBg:'#ff6034'}`">
      <ul class="main">
        <li :class="$store.state.groupId == 0 ? 'active' : ''">
          <a @click="allGroup">全部</a>
        </li>
        <li v-for="item in groupList" :key="item.id" :class="$store.state.groupId == item.id ? 'active' : ''">
          <a @click="goGroup(item.id)">{{ item.name }}</a>
        </li>
      </ul>
    </div>
    <router-view></router-view>
    
    <FloatButton1></FloatButton1>
    <div class="footer" :style="`border-top:solid 2px ${basic.pcHeadBg?basic.pcHeadBg:'#ff6034'}`">
      <div class="footer_cont">
        <div v-html="basic.link" class="link"></div>
        <div v-html="basic.copy" class="copy"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    getSalesShop,
  } from "@/api/index";
  import {
    mapState
  } from "vuex";
  export default {
    data() {
      return {
        SalesShop: [],
        groupList: [],
        
        search: this.$store.state.search,
      };
    },
    computed: {
      ...mapState(["basic"])
    },
    created() {
      if (document.body.clientWidth < 992) {
        let url = this.$route.name.replace('pc', 'mobile')
        this.$router.push({
          name: url
        });
      }
      this._getSalesShop();
    },
    watch: {
      search(newVal,oldVal){
        if(newVal != oldVal){
          this.searchClick()
        }
      },
      // 监听路由刷新
      $route: {
        handler: function (val, oldVal) {
          if (val.path != '/' && val.path != '/search') {
            this.$store.state.groupId = -1;
          }
        },
        // 深度观察监听
        deep: true,
      },

    },
    
    methods: {

      
      // 获取销量商品
      _getSalesShop() {
        getSalesShop({
          num:4
        }).then((res) => {
          this.SalesShop = res.data.salesShop;
          this.groupList = res.data.group;
        });
      },
      //  全部分类
      allGroup() {
        this.$store.state.groupId = "";
        this.search = ""
        this.$router.push('/')
      },
      // 跳转分类
      goGroup(id) {
        this.$store.state.groupId = id;
        this.$router.push('/search?group=' + id)
      },
      // 搜索
      searchClick() {
        this.$store.state.search = this.search;
        this.$router.push('/search?wd=' + this.search)
      },

    
    },
  };
</script>

<style lang="less" scoped>
  @import "../../../../assets/css/clean.css";
  @deep: ~">>>";

  .page-template {
    background: #fff;

    .topbar {
      width: 100%;
      height: 40px;
      position: relative;
      background: #f2f2f2;
      -webkit-transform: translate3d(0, 0, 0);
      border-bottom: 1px solid #e5e5e5;
      line-height: 40px;
      color: #999;
      font-size: 12px;

      .main {
        margin: 0 auto;
        width: 100%;
        max-width: 1230px;

        .topbar_left {
          float: left;
        }

        .topbar_right {
          float: right;

          a {
            margin-left: 10px;
            color: #999;
            cursor: pointer;
          }

          a:hover {
            color: blue;
          }
        }
      }
    }

    .midbar {
      height: 130px;
      background-color: #fff;

      .main {
        margin: 0 auto;
        width: 100%;
        max-width: 1230px;

        .midbar_left {
          float: left;
          height: 130px;
          width: 300px;
          position: relative;

          img {
            width: 100%;
            height: 100%;
            object-fit: scale-down;
          }

          .spin-container {}
        }

        .midbar_right {
          float: right;
          max-width: 100%;
          width: 625px;

          .search {
            width: 100%;
            margin: 31px auto;

            .search-main {
              width: 100%;
              height: 40px;
              border: solid 2px #ff4500;
              border-radius: 2px;

              .search-input {
                width: 80%;
                margin-top: 1px;
                height: 35px;
                font-size: 16px;
                padding: 0 10px;
                border: 0;
              }

              .search-button {
                width: 20%;
                border: 0;
                background: #ff4500;
                color: #ffffff;
                font-size: 16px;
                height: 38px;
              }
            }

            ul {
              width: 625px;
              height: 16px;
              overflow: hidden;
              list-style: none;
              margin: 10px 0;

              li {
                float: left;
                display: inline-block;
                border-left: 1px solid #ccc;
                line-height: 1.1;
                padding: 0 12px;
                font-size: 14px;
                color: #888;
                cursor: pointer;
              }

              li:first-child {
                border-left: 0;
                padding-left: 0;
              }
            }
          }
        }
      }
    }

    .navbar {
      background-color: #ff4500;
      height: 40px;
      width: 100%;
      overflow: hidden;

      .main {
        margin: 0 auto;
        width: 100%;
        max-width: 1230px;
        overflow: hidden;

        li:hover {
          background: #0066ff;

          border-bottom: 1px solid #0066ff;
        }

        li {
          cursor: pointer;
          float: left;
          height: 40px;

          a {
            display: block;
            font-size: 16px;
            padding: 0 10px;
            font-weight: 700;
            line-height: 38px;
            color: #fff;
          }
        }
      }
    }

    

    .footer {
      border-top: solid 2px #ff4500;
      background-color: #fff;
      padding: 20px 0;

      .footer_cont {
        text-align: center;
        font-size: 12px;
        width: 100%;
        max-width: 1230px;
        margin: 0 auto;

        .copy {
          margin-top: 10px;
        }

        @{deep}.link a {
          margin: 0 10px;
        }
      }
    }

    .active {
      background: #0066ff;
      border-bottom: 1px solid #0066ff;
    }


  }
</style>